import React, { useState } from "react";

const legalOptions = [
  "Family Law",
  "Criminal Law",
  "Employment Law",
  "Business Law",
  "Immigration Law",
  "Personal Injury",
];

const servicesList = [
  "ITRs, TDS, TDS Filing",
  "E-Stamp paper (Non-Judicial)",
  "Property Registration",
  "Marriage Registration",
  "Certified copies / EC",
  "Revenue Documents",
  "Katha & Tax Transfer",
  "Affidavit",
  "Indemnity bond",
  "K 2 Challan",
  "Name Approval (LLP & Pvt Ltd)",
  "LLP Registration",
  "Pvt Ltd Company",
  "GST Registration & Filing",
  "Transaction Management",
  "Post-Transaction Support",
  "Plan Approvals",
  "Land Survey (Manual & Electronic)",
  "Construction on a turnkey basis",
  "Property Consultancy",
  "Market Analysis and Trends",
  "Property Valuation",
  "Investment Advice",
  "Feasibility Studies",
];

export default function ExpertAdviceForm() {
// Initial state
const [form, setForm] = useState({
  fullName: "",
  dob: "",
  email: "",
  phone: "",
  address1: "",
  address2: "",
  address3: "",
  preferredContact: "Email",
  legalIssues: [],
  otherLegalIssue: "",
  services: [],
  otherService: "",
  description: "",
  incidentDate: "",
  priorHelp: "No",
  priorHelpDetails: "",
  desiredOutcome: "",
  deadline: "No",
  deadlineDetails: "",
  howHear: "",
  additionalComments: "",
  signature: "",
  signatureDate: ""
});
 const [showThankYou, setShowThankYou] = useState(false);

  const [errors, setErrors] = useState({});

const toggleArrayValue = (key, value) => {
  setForm((prev) => {
    const arr = prev[key];
    if (arr.includes(value)) {
      return { ...prev, [key]: arr.filter((v) => v !== value) };
    } else {
      return { ...prev, [key]: [...arr, value] };
    }
  });
};

const validate = () => {
  const e = {};
  if (!form.fullName.trim()) e.fullName = "Full name is required.";
  if (!form.email.trim() && !form.phone.trim())
    e.contact = "Please provide at least an email or phone number.";
  return e;
};

const handleSubmit = async (ev) => {
  ev.preventDefault();
  const e = validate();
  if (Object.keys(e).length) {
    setErrors(e);
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  const payload = {
    full_name: form.fullName,
    dob: form.dob,
    email: form.email,
    phone: form.phone,
    address1: form.address1,
    address2: form.address2,
    address3: form.address3,
    preferred_contact: form.preferredContact,
    legal_issues: form.legalIssues,
    other_legal_issue: form.otherLegalIssue,
    services: form.services,
    other_service: form.otherService,
    description: form.description,
    incident_date: form.incidentDate,
    prior_help: form.priorHelp,
    prior_help_details: form.priorHelpDetails,
    desired_outcome: form.desiredOutcome,
    deadline: form.deadline,
    deadline_details: form.deadlineDetails,
    how_hear: form.howHear,
    additional_comments: form.additionalComments,
    signature: form.signature,
    signature_date: form.signatureDate
  };

  try {
    const response = await fetch('https://charethribs.com/api/expertadvice', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(`Network response was not ok: ${errorMessage}`);
    }

    const result = await response.json();
   if (result.success) {
  setShowThankYou(true);
  // Reset form if you want
  setForm({
    fullName: "",
    dob: "",
    email: "",
    phone: "",
    address1: "",
    address2: "",
    address3: "",
    preferredContact: "Email",
    legalIssues: [],
    services: [],
    otherLegalIssue: "",
    otherService: "",
    description: "",
    incidentDate: "",
    priorHelp: "No",
    priorHelpDetails: "",
    desiredOutcome: "",
    deadline: "No",
    deadlineDetails: "",
    howHear: "",
    additionalComments: "",
    signature: "",
    signatureDate: "",
  });

  setTimeout(() => {
    setShowThankYou(false);
  }, 3000); // message will disappear after 3 seconds
} else {
  alert('There was an error submitting your inquiry. Please try again.');
}

  } catch (error) {
    console.error('Error:', error);
    alert('There was an error submitting your inquiry. Please try again.');
  }
};









  return (
    <div className="max-w-5xl mx-auto p-6  ">
      <h2 className="text-2xl font-semibold mb-4 text-[#b7b7a1]">Expert Advice — Inquiry Form</h2>

      {Object.keys(errors).length > 0 && (
        <div className="mb-4 p-3 rounded border border-red-300 bg-red-50 text-red-700">
          Please fix the highlighted errors before submitting.
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Client Information */}
        <section aria-labelledby="client-info">
          <h3 id="client-info" className="text-lg font-medium text-[#b7b7a1]">Client Information</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
            <label className="flex flex-col">
              <span className="mb-1 text-sm text-[#b7b7a1]">Full Name *</span>
              <input
                type="text"
                value={form.fullName}
                onChange={(e) => setForm({ ...form, fullName: e.target.value })}
                className={`border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 ${
                  errors.full_name ? "border-red-400" : "border-gray-300"
                }`}
                placeholder="Enter full name"
              />
              {errors.fullName && <small className="text-red-500 mt-1">{errors.fullName}</small>}
            </label>

            <label className="flex flex-col">
              <span className="mb-1 text-sm text-[#b7b7a1]">Date of Birth</span>
              <input
                type="date"
                value={form.dob}
                onChange={(e) => setForm({ ...form, dob: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
              />
            </label>

            <label className="flex flex-col">
              <span className="mb-1 text-sm text-[#b7b7a1]">Email Address *</span>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                placeholder="you@example.com"
              />
            </label>

            <label className="flex flex-col">
              <span className="mb-1 text-sm text-[#b7b7a1]">Phone Number *</span>
              <input
                type="tel"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                placeholder="+91 9*********"
              />
            </label>
          </div>

          <div className="mt-4">
            <label className="flex flex-col">
              <span className="mb-1 text-sm text-[#b7b7a1]">Mailing Address</span>
              <input
                type="text"
                value={form.address1}
                onChange={(e) => setForm({ ...form, address1: e.target.value })}
                className="mb-2 border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                placeholder="Address line 1"
              />
              <input
                type="text"
                value={form.address2}
                onChange={(e) => setForm({ ...form, address2: e.target.value })}
                className="mb-2 border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                placeholder="Address line 2"
              />
              <input
                type="text"
                value={form.address3}
                onChange={(e) => setForm({ ...form, address3: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                placeholder="City, State, Pincode"
              />
            </label>
          </div>

          <div className="mt-4">
            <label className="flex items-center gap-3">
              <span className="text-sm text-[#b7b7a1] w-44">Preferred Contact Method</span>
              <select
                value={form.preferredContact}
                onChange={(e) => setForm({ ...form, preferredContact: e.target.value })}
                className="flex-1 border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
              >
                <option>Email</option>
                <option>Phone</option>
                <option>Mail</option>
              </select>
            </label>
          </div>
        </section>

        {/* Legal Details */}
        <section>
          <h3 className="text-lg font-medium text-[#b7b7a1]">Legal Details</h3>

          <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <p className="text-sm text-[#b7b7a1] mb-2">Type of Legal Issues</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {legalOptions.map((opt) => (
                  <label key={opt} className="inline-flex items-center gap-2 text-sm">
                    <input
                      type="checkbox"
                      checked={form.legalIssues.includes(opt)}
                      onChange={() => toggleArrayValue("legalIssues", opt)}
                      className="h-4 w-4"
                    />
                    <span className="text-[#b7b7a1]">{opt}</span>
                  </label>
                ))}
              </div>
              <div className="mt-2">
                <input
                  type="text"
                  placeholder="Other (please specify)"
                  value={form.otherLegalIssue}
                  onChange={(e) => setForm({ ...form, otherLegalIssue: e.target.value })}
                  className="w-full border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300 text-sm"
                />
              </div>
            </div>

            <div>
              <p className="text-sm text-[#b7b7a1] mb-2">Services Required</p>
              <div className="max-h-44 overflow-auto border rounded p-3 space-y-2 bg-white/50">
                {servicesList.map((srv) => (
                  <label key={srv} className="inline-flex items-center gap-2 text-sm w-full">
                    <input
                      type="checkbox"
                      checked={form.services.includes(srv)}
                      onChange={() => toggleArrayValue("services", srv)}
                      className="h-4 w-4"
                    />
                    <span className="text-[#b7b7a1]">{srv}</span>
                  </label>
                ))}
                <div className="mt-2">
                  <input
                    type="text"
                    placeholder="Other service (please specify)"
                    value={form.otherService}
                    onChange={(e) => setForm({ ...form, otherService: e.target.value })}
                    className="w-full border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300 text-sm"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <label className="flex flex-col">
              <span className="text-sm text-[#b7b7a1] mb-1">Brief Description of the Issue</span>
              <textarea
                value={form.description}
                onChange={(e) => setForm({ ...form, description: e.target.value })}
                rows={5}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                placeholder="Provide as much detail as possible..."
              />
            </label>
          </div>

          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <label className="flex flex-col">
              <span className="text-sm text-[#b7b7a1]">Date of Incident/Issue/Registration</span>
              <input
                type="date"
                value={form.incidentDate}
                onChange={(e) => setForm({ ...form, incidentDate: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
              />
            </label>

            <label className="flex flex-col">
              <span className="text-sm text-[#b7b7a1]">Have you previously sought legal assistance?</span>
              <select
                value={form.priorHelp}
                onChange={(e) => setForm({ ...form, priorHelp: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
              >
                <option>No</option>
                <option>Yes</option>
              </select>
            </label>

            {form.priorHelp === "Yes" && (
              <label className="flex flex-col">
                <span className="text-sm text-[#b7b7a1]">If yes, please provide details</span>
                <input
                  type="text"
                  value={form.priorHelpDetails}
                  onChange={(e) => setForm({ ...form, priorHelpDetails: e.target.value })}
                  className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                  placeholder="Details about prior assistance"
                />
              </label>
            )}
          </div>
        </section>

        {/* Desired Remedy & Time Sensitivity */}
        <section>
          <h3 className="text-lg font-medium text-[#b7b7a1]">Desired Remedy & Timing</h3>

          <div className="mt-3">
            <label className="flex flex-col">
              <span className="text-sm text-[#b7b7a1]">What outcome are you seeking?</span>
              <textarea
                value={form.desiredOutcome}
                onChange={(e) => setForm({ ...form, desiredOutcome: e.target.value })}
                rows={3}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                placeholder="Describe the desired result or remedy"
              />
            </label>
          </div>

          <div className="mt-3 flex flex-col md:flex-row md:items-center gap-3">
            <label className="flex items-center gap-3">
              <input
                type="radio"
                name="deadline"
                value="No"
                checked={form.deadline === "No"}
                onChange={() => setForm({ ...form, deadline: "No", deadlineDetails: "" })}
              />
              <span className="text-[#b7b7a1] text-sm">No urgent deadline</span>
            </label>

            <label className="flex items-center gap-3">
              <input
                type="radio"
                name="deadline"
                value="Yes"
                checked={form.deadline === "Yes"}
                onChange={() => setForm({ ...form, deadline: "Yes" })}
              />
              <span className="text-[#b7b7a1] text-sm">There is a deadline</span>
            </label>

            {form.deadline === "Yes" && (
              <input
                type="text"
                placeholder="Specify deadline / time-sensitive details"
                value={form.deadlineDetails}
                onChange={(e) => setForm({ ...form, deadlineDetails: e.target.value })}
                className="flex-1 border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
              />
            )}
          </div>
        </section>

        {/* Additional Info */}
        <section>
          <h3 className="text-lg font-medium text-[#b7b7a1]">Additional Information</h3>

          <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
            <label className="flex flex-col">
              <span className="text-sm text-[#b7b7a1]">How did you hear about our services?</span>
              <select
                value={form.howHear}
                onChange={(e) => setForm({ ...form, howHear: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
              >
                <option value="">Select</option>
                <option>Referral</option>
                <option>Website</option>
                <option>Social Media</option>
                <option>Advertisement</option>
                <option>Other</option>
              </select>
            </label>

            <label className="flex flex-col">
              <span className="text-sm text-[#b7b7a1]">Any additional comments</span>
              <input
                type="text"
                value={form.additionalComments}
                onChange={(e) => setForm({ ...form, additionalComments: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
                placeholder="Anything else you'd like to add"
              />
            </label>
          </div>

          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
            <label className="flex flex-col">
              <span className="text-sm text-[#b7b7a1]">Signature (type full name)</span>
              <input
                type="text"
                value={form.signature}
                onChange={(e) => setForm({ ...form, signature: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
              />
            </label>

            <label className="flex flex-col">
              <span className="text-sm text-[#b7b7a1]">Date</span>
              <input
                type="date"
                value={form.signatureDate}
                onChange={(e) => setForm({ ...form, signatureDate: e.target.value })}
                className="border rounded px-3 py-2 bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-300 border-gray-300"
              />
            </label>
          </div>
        </section>

        <div className="flex items-center gap-3">
          <button
            type="submit"
            className="px-5 py-2 rounded bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
          >
            Submit Inquiry
          </button>

          <button
            type="button"
            onClick={() =>
              setForm({
                fullName: "",
                dob: "",
                email: "",
                phone: "",
                address1: "",
                address2: "",
                address3: "",
                preferredContact: "Email",
                legalIssues: [],
                services: [],
                otherLegalIssue: "",
                otherService: "",
                description: "",
                incidentDate: "",
                priorHelp: "No",
                priorHelpDetails: "",
                desiredOutcome: "",
                deadline: "No",
                deadlineDetails: "",
                howHear: "",
                additionalComments: "",
                signature: "",
                signatureDate: "",
              })
            }
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 bg-transparent"
          >
            Reset
          </button>
        </div>

        <p className="text-xs text-gray-500 mt-2">
          By submitting this form you acknowledge that this does not create an attorney-client relationship.
        </p>
      </form>
        {showThankYou && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-lg text-center max-w-sm mx-4">
            <h3 className="text-xl font-semibold mb-2">Thank You!</h3>
            <p>Your inquiry has been submitted successfully.</p>
          </div>
        </div>
      )}
    </div>
  );
}
